import React, {useCallback, useEffect, useState} from 'react';
import {Button, ButtonProps, CircularProgress} from "@mui/material";

type IProps = {
    onClick: () => Promise<void> | void,
    refreshInterval?: number
} & ButtonProps

const LoadingButton: React.FC<IProps> = ({refreshInterval, onClick, ...render}) => {
    const [loading, setLoading] = useState(false)
    const [secondsBeforeRefresh, setSecondsBeforeRefresh] = useState(refreshInterval || 0)

    useEffect(() => {
        if (refreshInterval) {
            const timer = setInterval(() => setSecondsBeforeRefresh(prev => Math.max(prev - 1, 0)), 1000);
            return () => clearInterval(timer)
        }
    }, [refreshInterval])

    const handle = useCallback(() => {
        setLoading(true)
        Promise.resolve(onClick())
                .finally(() => {
                    setLoading(false)
                    setSecondsBeforeRefresh(refreshInterval || 0)
                });
    }, [onClick, refreshInterval])

    useEffect(() => {
        if (refreshInterval && secondsBeforeRefresh === 0) {
            handle();
        }
    }, [refreshInterval, secondsBeforeRefresh, handle])

    if (loading) {
        return <Button {...render} disabled onClick={undefined} startIcon={<CircularProgress size="1.2rem"/>}/>;
    } else {
        return <Button {...render} onClick={handle} endIcon={refreshInterval ? "(" + secondsBeforeRefresh + ")" : undefined}/>;
    }
}

export default LoadingButton;